// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7eabad1c","239":"5b94bab1","393":"ce986a04","453":"5570914a","732":"c348bfe0","888":"b3c952ad"}[chunkId] + ".chunk.js";
};